/** Client-side checks before starting a PDF upload (extension, size). */
export function validatePdfUploadFile(file: File): string | null {
  if (!file.name.toLowerCase().endsWith('.pdf')) {
    return 'Please upload a .pdf file';
  }
  if (file.size === 0) {
    return 'The file is empty. Choose a valid PDF.';
  }
  if (file.size > 25 * 1024 * 1024) {
    return 'File too large. Maximum size is 25 MB.';
  }
  return null;
}